import {
 CHANGE_SEARCH_FIELD,
 REQUEST_ROOMS_PENDING,
 REQUEST_ROOMS_SUCCESS,
 REQUEST_ROOMS_FAILED,
 CHANGE_MODAL
} from './constants'

export const setSearchField = (text) => ({
	type: CHANGE_SEARCH_FIELD,
	payload: text
})

export const requestRooms = () => (dispatch) => {
	dispatch({ type: REQUEST_ROOMS_PENDING });
		fetch('https://rooms-escape.com/rooms')
		.then(response => response.json())
		.then(data => dispatch({ type: REQUEST_ROOMS_SUCCESS, payload: data.rooms }))
		.catch(error => dispatch({ type: REQUEST_ROOMS_FAILED, payload: error }))
}

export const setToggleModal = (id) => ({
	type: CHANGE_MODAL,
	payload: id
})


// WEBPACK FOOTER //
// ./src/actions.js